module.exports = __webpack_public_path__ + "images/banners/pages_iphone/spots_right_a568392d7079b448e93797ee383df691.png";